module.exports = __webpack_public_path__ + "static/2front-sm-3-4494678071a1129910baade34e3fd6a4.png";